// extracted by mini-css-extract-plugin
module.exports = {"pintxo-illustration":"Illustration_pintxo-illustration__ejSTm"};